import REST from '../rest';

export const signIn = (data) => REST.post('oauth/token', data, {}, { 'Content-Type': 'application/json' });

export const signOut = (token) => REST.post('oauth/revoke', { token }, {}, { 'Content-Type': 'application/json' });
